export default __webpack_public_path__ + "static/1854-358502ec2f1a79642c9bdb1de121b2fe.gif";